import { useSelector } from 'react-redux';
import { getHighlightSector } from '../selectors';

export const useHighlightSector = () => useSelector(getHighlightSector);
